import { render, staticRenderFns } from "./CardItem3.vue?vue&type=template&id=4474214a&scoped=true&"
import script from "./CardItem3.vue?vue&type=script&lang=js&"
export * from "./CardItem3.vue?vue&type=script&lang=js&"
import style0 from "./CardItem3.vue?vue&type=style&index=0&id=4474214a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4474214a",
  null
  
)

export default component.exports